import { usePickerContext } from "./usePickerContext";

/**
 * Build ticket item with more data
 * @returns {{dates: *}}
 * @param payloads
 */
export const useTicketsBuilder = ({ onlyCurrentDate = false, sortByDate = false } = {}) => {
    // console.log('useTicketsBuilder')

    const { state } = usePickerContext();
    // console.log(state.dates)
    const currentDate = state.dates.find(date => date.current);
    // console.log(currentDate);
    const currentHourValue = Object.keys(currentDate.hours).find(value => currentDate.hours[value].current);

    let payload = state.tickets;
    // console.log(payload)
    // console.log(onlyCurrentDate)
    if (onlyCurrentDate) payload = payload.filter(ticket => ticket.at === currentDate.at && ticket.hour === currentHourValue);
    // console.log(payload)
    let tickets = payload.map(ticket => {
        const date = state.dates.find(date => {
            // console.log(Object.keys(date.hours).indexOf(ticket.hour))
            // console.log(Object.keys(date.hours)[0])
            // console.log(Object.keys(date.hours)[1])
            // console.log(date.at === ticket.at && parseInt(Object.keys(date.hours)[Object.keys(date.hours).indexOf(ticket.hour)]) === parseInt(ticket.hour));
            return date.at === ticket.at && parseInt(Object.keys(date.hours)[Object.keys(date.hours).indexOf(ticket.hour)]) === parseInt(ticket.hour)
        });
        // console.log(date);
        const hour = date.hours[ticket.hour];

        const category = hour.widget.categories.find(category => category.id === ticket.categoryId);
        const formulas = hour.widget.pricing.filter(price => price.categoryId === ticket.categoryId);

        let selectedFormula = formulas[0];
        if (ticket.formulaCode) {
            selectedFormula = formulas.find(price => price.formulaCode === ticket.formulaCode)
        }

        let location = null;
        switch (ticket.type) {
            case 'SEAT':
                location = ticket.id;
                break;
            case 'PIT':
                location = '-';
                break;
        }

        return {
            ...ticket,
            category,
            formulas,
            location,
            date,
            hour,
            selectedFormula
        }
    });

    tickets = tickets.filter(ticket => !!ticket)

    let total = 0;
    tickets.forEach(ticket => total += ticket.selectedFormula.price);

    if (sortByDate) {
        return {
            total,
            dates: state.dates.map(date => {
                return {
                    ...date,
                    hours: Object.keys(date.hours).map(value => {

                        let ticketsForHour;
                        if (state.typeWidget === 'PASS') {
                            ticketsForHour = tickets.filter(ticket => ticket.at === date.at);
                        } else {
                            ticketsForHour = tickets.filter(ticket => ticket.hour === value);
                        }

                        let total = 0;
                        ticketsForHour.forEach(ticket => total += ticket.selectedFormula.price);
                        return {
                            ...date.hours[value],
                            at: value,
                            total,
                            tickets: ticketsForHour
                        }
                    })
                }

            })
        };
    }

    return { tickets, total }
};